module.exports = __webpack_public_path__ + "img/1.92fdef0a.png";